export default "/assets/images/construction.6b400e47dccd8368.png";